import React from 'react';
import { twMerge } from 'tailwind-merge';
type Variant = 'primary' | 'accent' | 'outline' | 'ghost';
type Size = 'md' | 'lg';
const base = 'inline-flex items-center justify-center gap-2 rounded-full font-semibold tracking-tight transition-[background-color,color,border-color,transform,box-shadow] duration-150 ease-smooth focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-royal-600 active:scale-[0.98] disabled:opacity-60 disabled:pointer-events-none whitespace-nowrap';
const variants: Record<Variant, string> = {
  primary: 'bg-royal-600 text-white hover:bg-royal-700 shadow-sm',
  accent: 'bg-turq-400 text-ash-900 hover:bg-turq-300',
  outline: 'border border-ash-300 bg-white text-ash-900 hover:border-royal-600 hover:text-royal-700',
  ghost: 'text-royal-700 hover:bg-royal-50'
};
const sizes: Record<Size, string> = {
  md: 'h-11 px-5 text-sm',
  lg: 'h-14 px-8 text-base'
};
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}
export function Button({
  variant = 'primary',
  size = 'md',
  className,
  ...props
}: ButtonProps) {
  return <button className={twMerge(base, variants[variant], sizes[size], className)} {...props} data-id="element-212" data-mp="erh93l5u8nkk" />;
}
interface LinkButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: Variant;
  size?: Size;
}
export function LinkButton({
  variant = 'primary',
  size = 'md',
  className,
  ...props
}: LinkButtonProps) {
  return <a className={twMerge(base, variants[variant], sizes[size], className)} {...props} data-id="element-213" data-mp="xoicj1jqufme" />;
}